import { transparentize } from 'color2k';
import { DefaultRow, type TableRowProps } from 'common/Table';
import { useState } from 'react';
import { Colors } from 'styles';
import type { RightDrawerTableItemType, RightDrawerTabType } from './types';
import { useRowClickIntent } from './useRowClickIntent';

type RightDrawerTableRowProps = TableRowProps<RightDrawerTableItemType> & {
  activeTab: RightDrawerTabType;
  getRowAction: (item: RightDrawerTableItemType) => RightDrawerTableItemType;
  onRowClick: (item: RightDrawerTableItemType) => Promise<void>;
  onRowDoubleClick: (item: RightDrawerTableItemType) => Promise<void>;
  selectedTemplateId?: string;
};

export function RightDrawerTableRow({
  row,
  activeTab,
  getRowAction,
  onRowClick,
  onRowDoubleClick,
  selectedTemplateId,
  ...props
}: RightDrawerTableRowProps) {
  const [isHovered, setIsHovered] = useState(false);
  const [isClicked, setIsClicked] = useState(false);
  const onRowMouseDown = useRowClickIntent({
    getRowAction,
    onRowClick,
    onRowDoubleClick,
  });

  return (
    <DefaultRow
      row={row}
      className={isHovered ? 'hovered' : isClicked ? 'clicked' : ''}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => {
        setIsHovered(false);
        setIsClicked(false);
      }}
      onMouseDown={(e) => {
        setIsClicked(true);
        onRowMouseDown(e, row.original);
      }}
      data-testid={`${activeTab}-${row.original.name}`}
      css={`
        user-select: none;
        cursor: pointer;
        border-bottom: 1px solid rgba(236, 236, 236, 0.12);
        opacity: 1;
        background-color: ${selectedTemplateId === row.original.id
          ? transparentize(Colors.blue2, 0.5)
          : '#000a12'};
        .editIcon,
        .insertIcon,
        .cloneIcon {
          opacity: 0;
        }

        &:hover .insertIcon,
        &:focus .insertIcon,
        &:hover .editIcon,
        &:focus .editIcon,
        &:hover .cloneIcon,
        &:focus .cloneIcon {
          opacity: 1;
        }

        &:hover,
        &:focus {
          opacity: 1;
          background-color: ${selectedTemplateId === row.original.id ? Colors.blue2 : Colors.gray6};
        }
      `}
      {...props}
    />
  );
}
